<template>
  <div class="select-none">
    <!-- Свёрнутое состояние: таблетка -->
    <button
      v-if="!expanded && !alwaysOpen"
      @click="expanded = true"
      aria-label="Развернуть витамины и минералы"
      class="relative w-full rounded-xl overflow-hidden flex items-center justify-between"
      style="height: 32px; background: #EDE5D8; padding: 0 8px;"
    >
      <span
        class="leading-none text-ink"
        style="font-family: Inter, sans-serif; font-size: var(--fs-14); font-weight: 600;"
      >Витамины и минералы</span>
      <span v-if="loading" class="flex items-center gap-1">
        <svg class="animate-spin" width="14" height="14" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="#D9D0C4" stroke-width="3"/>
          <path d="M12 2a10 10 0 0 1 10 10" stroke="#8B7B6B" stroke-width="3" stroke-linecap="round"/>
        </svg>
        <span style="font-family: Inter, sans-serif; font-size: var(--fs-11); font-weight: 400; color: var(--ink-70);">пересчитываю...</span>
      </span>
      <!-- Только шеврон, как в поле даты рождения: вниз — блок свёрнут,
           вверх — развёрнут (владелец, 10.10.2026; раньше «развернуть ↓» /
           «свернуть ↑», затем залитый треугольник) -->
      <span v-else class="flex items-center text-ink" style="padding: 0 2px;"><svg class="vb-tri" width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
    </button>

    <!-- Развёрнутое состояние: контейнер -->
    <div v-else :class="alwaysOpen ? 'vitamins-open' : 'rounded-xl overflow-hidden'" :style="alwaysOpen ? undefined : { background: '#EDE5D8', padding: '0 8px 10px' }">
      <h2 v-if="alwaysOpen" class="vitamins-title">Витамины и минералы</h2>
      <!-- Заголовок внутри контейнера -->
      <button
        v-if="!alwaysOpen"
        @click="expanded = false"
        aria-label="Свернуть витамины и минералы"
        class="w-full flex items-center justify-between"
        style="height: 32px; margin-bottom: 2px;"
      >
        <span
          class="leading-none text-ink"
          style="font-family: Inter, sans-serif; font-size: var(--fs-14); font-weight: 600;"
        >Витамины и минералы</span>
        <span class="flex items-center text-ink" style="padding: 0 2px;"><svg style="transform: rotate(180deg);" class="vb-tri" width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
      </button>

      <!-- Лоадер при пересчёте -->
      <div v-if="loading" class="flex items-center gap-2 mb-2">
        <svg class="animate-spin" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="#D9D0C4" stroke-width="3"/>
          <path d="M12 2a10 10 0 0 1 10 10" stroke="#8B7B6B" stroke-width="3" stroke-linecap="round"/>
        </svg>
        <span style="font-family: Inter, sans-serif; font-size: var(--fs-12); font-weight: 400; color: var(--ink-70);">
          Пересчитываю витамины и минералы, это займёт несколько секунд...
        </span>
      </div>

      <!-- Две колонки -->
      <div class="flex" style="gap: 36px;">

        <!-- ЛЕВАЯ КОЛОНКА: витамины -->
        <div class="flex flex-col" style="gap: 6px; flex: 1; min-width: 0;">
          <div
            v-for="item in vitaminRows"
            :key="item.key"
            class="flex items-center"
            style="gap: 3px; height: 16px;"
          >
            <span class="shrink-0" style="font-family: Inter, sans-serif; font-size: var(--fs-14); font-weight: 600; color: var(--ink); width: 24px;">{{ item.label }}</span>
            <div class="flex-1 relative rounded-full overflow-hidden" style="height: 16px; background: #D1C8C8;">
              <div
                class="absolute left-0 top-0 bottom-0 rounded-full"
                :style="{ width: Math.min(item.pct, 100) + '%', backgroundColor: vitaminColor(item.key) }"
              />
            </div>
            <span class="shrink-0" style="font-family: Inter, sans-serif; font-size: var(--fs-12); font-weight: 600; text-align: right;"
                  :style="{ color: item.value != null ? '#41291A' : '#C4B8A8', width: noData && item.value == null ? 'auto' : '34px' }">
              {{ item.value != null ? item.pct + '%' : (noData ? 'н/д' : '—') }}
            </span>
          </div>
        </div>

        <!-- ПРАВАЯ КОЛОНКА: минералы -->
        <div class="flex flex-col" style="gap: 6px; flex: 1; min-width: 0;">
          <div
            v-for="item in mineralRows"
            :key="item.key"
            class="flex items-center"
            style="gap: 3px; height: 16px;"
          >
            <span class="shrink-0" style="font-family: Inter, sans-serif; font-size: var(--fs-14); font-weight: 600; color: var(--ink); width: 24px;">{{ item.label }}</span>
            <div class="flex-1 relative rounded-full overflow-hidden" style="height: 16px; background: #D1C8C8;">
              <div
                class="absolute left-0 top-0 bottom-0 rounded-full"
                :style="{ width: Math.min(item.pct, 100) + '%', backgroundColor: '#D476A5' }"
              />
            </div>
            <span class="shrink-0" style="font-family: Inter, sans-serif; font-size: var(--fs-12); font-weight: 600; text-align: right;"
                  :style="{ color: item.value != null ? '#41291A' : '#C4B8A8', width: noData && item.value == null ? 'auto' : '34px' }">
              {{ item.value != null ? item.pct + '%' : (noData ? 'н/д' : '—') }}
            </span>
          </div>
        </div>

      </div>

      <!-- Статус учёта витаминов (только для дневника) -->
      <template v-if="showCoverage">
        <p v-if="noVitaminsList.length > 0"
           class="mt-2"
           style="font-family: Inter, sans-serif; font-size: var(--fs-11); font-weight: 400; color: var(--ink-70); line-height: 1.4;">
          *Не учтены витамины и минералы: {{ noVitaminsList.join(', ') }}
        </p>
        <p v-else-if="hasAnyVitamins"
           class="mt-2"
           style="font-family: Inter, sans-serif; font-size: var(--fs-11); font-weight: 400; color: var(--ink-70); line-height: 1.4;">
          ✓ По всем добавленным продуктам найдены данные по содержанию витаминов и минералов
        </p>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  alwaysOpen: { type: Boolean, default: false },
  totals:          { type: Object,  default: () => ({}) },
  sex:             { type: String,  default: 'm' },
  age:             { type: Number,  default: null },
  defaultExpanded: { type: Boolean, default: false },
  loading:         { type: Boolean, default: false },
  showCoverage:    { type: Boolean, default: false },
  noData:          { type: Boolean, default: false },
})

const expanded = ref(props.defaultExpanded)

const FAT_SOLUBLE = ['A', 'D', 'E', 'K']
function vitaminColor(key) {
  return FAT_SOLUBLE.includes(key) ? '#DEAE00' : '#7EB04E'
}

// RDA/AI по возрастным группам и полу (источник: NIH/NCBI DRI tables)
// Группы: 14-18, 19-50, 51-70, 71+
// Формат: [m14, f14, m19, f19, m51, f51, m71, f71]
const RDI_TABLE = {
  //            14-18 M/F     19-50 M/F     51-70 M/F     71+ M/F
  A:   { vals: [900,  700,    900,  700,    900,  700,    900,  700  ] },
  D:   { vals: [15,   15,     15,   15,     15,   15,     20,   20   ] },
  E:   { vals: [15,   15,     15,   15,     15,   15,     15,   15   ] },
  K:   { vals: [75,   75,     120,  90,     120,  90,     120,  90   ] },
  C:   { vals: [75,   65,     90,   75,     90,   75,     90,   75   ] },
  B1:  { vals: [1.2,  1.0,    1.2,  1.1,    1.2,  1.1,    1.2,  1.1  ] },
  B2:  { vals: [1.3,  1.0,    1.3,  1.1,    1.3,  1.1,    1.3,  1.1  ] },
  B3:  { vals: [16,   14,     16,   14,     16,   14,     16,   14   ] },
  B5:  { vals: [5,    5,      5,    5,      5,    5,      5,    5    ] },
  B6:  { vals: [1.3,  1.2,    1.3,  1.3,    1.7,  1.5,    1.7,  1.5  ] },
  B7:  { vals: [25,   25,     30,   30,     30,   30,     30,   30   ] },
  B9:  { vals: [400,  400,    400,  400,    400,  400,    400,  400  ] },
  B12: { vals: [2.4,  2.4,    2.4,  2.4,    2.4,  2.4,    2.4,  2.4  ] },
  K_m: { vals: [3000, 2300,   3400, 2600,   3400, 2600,   3400, 2600 ] },
  Ca:  { vals: [1300, 1300,   1000, 1000,   1000, 1200,   1200, 1200 ] },
  Mg:  { vals: [410,  360,    420,  320,    420,  320,    420,  320  ] },
  Na:  { vals: [1500, 1500,   1500, 1500,   1500, 1500,   1500, 1500 ] },
  Cl:  { vals: [2300, 2300,   2300, 2300,   2000, 2000,   1800, 1800 ] },
  Fe:  { vals: [11,   15,     8,    18,     8,    8,      8,    8    ] },
  I:   { vals: [150,  150,    150,  150,    150,  150,    150,  150  ] },
  Cu:  { vals: [890,  890,    900,  900,    900,  900,    900,  900  ] },
  Se:  { vals: [55,   55,     55,   55,     55,   55,     55,   55   ] },
  Mn:  { vals: [2.2,  1.6,    2.3,  1.8,    2.3,  1.8,    2.3,  1.8  ] },
  Cr:  { vals: [35,   24,     35,   25,     30,   20,     30,   20   ] },
  Mo:  { vals: [43,   43,     45,   45,     45,   45,     45,   45   ] },
  Zn:  { vals: [11,   9,      11,   8,      11,   8,      11,   8    ] },
  P:   { vals: [1250, 1250,   700,  700,    700,  700,    700,  700  ] },
}

function getNorm(key) {
  const entry = RDI_TABLE[key]
  if (!entry) return 0
  const age = props.age
  // Определяем индекс возрастной группы (пара m/f)
  let groupIdx
  if (age != null && age < 19) groupIdx = 0
  else if (age != null && age > 70) groupIdx = 3
  else if (age != null && age > 50) groupIdx = 2
  else groupIdx = 1 // 19-50 или возраст неизвестен
  const baseIdx = groupIdx * 2
  const female = props.sex === 'f' || props.sex === 'female'
  return female ? entry.vals[baseIdx + 1] : entry.vals[baseIdx]
}

const VITAMINS  = ['A', 'D', 'E', 'K', 'C', 'B1', 'B2', 'B3', 'B5', 'B6', 'B7', 'B9', 'B12']
const MINERALS  = ['K_m', 'Ca', 'Mg', 'Na', 'Cl', 'Fe', 'I', 'Cu', 'Se', 'Mn', 'Cr', 'Mo', 'Zn', 'P']
const LABELS    = { K_m: 'K' }

function makeRow(key) {
  const norm  = getNorm(key)
  const value = props.totals[key] ?? null
  const pct   = value != null && norm > 0 ? Math.round((value / norm) * 100) : null
  return { key, label: LABELS[key] ?? key, value, pct: pct ?? 0 }
}

const vitaminRows = computed(() => VITAMINS.map(makeRow))
const mineralRows = computed(() => MINERALS.map(makeRow))
const noVitaminsList = computed(() => {
  const list = props.totals?._no_vitamins
  return Array.isArray(list) ? list : []
})
const hasAnyVitamins = computed(() => {
  return Object.entries(props.totals || {}).some(([k, v]) => k !== '_no_vitamins' && v > 0)
})
</script>

<style scoped>
.vitamins-open { margin: 4px 0 30px; }
.vitamins-title { font-family: Inter, sans-serif; font-size: var(--fs-20); line-height: 1.2; font-weight: 700; color: var(--ink); margin: 0 0 16px; }
</style>
